import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import { LoadingSpinner } from './../../../components/Icons'
import CustomIconButton from "../../../components/CustomIconButton";
import CustomButton from "../../../components/CustomButton";
import CheckboxButton from "../../../components/CheckboxButton";
import { createStatus } from "../../../reducers/talentMypage";

interface ReceiveNewsEmailProps {
    onClose: () => void;
}

const ReceiveNewsEmail: React.FC<ReceiveNewsEmailProps> = ({ onClose }) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const talentMypage = useSelector((state: any) => state.talentMypage)
    const { isLoading } = useSelector((state: any) => state.talentMypage)
    const [isEditing, setIsEditing] = useState(false)
    const [isReceiveNewsEmail, setIsReceiveNewsEmail] = useState(talentMypage.talent?.do_want_news_email)
    const [isReceiveScoutEmail, setIsReceiveScoutEmail] = useState(talentMypage.talent?.do_want_scout_email)

    const saveChange = () => {
        if(isReceiveNewsEmail == talentMypage?.talent?.do_want_news_email && isReceiveScoutEmail == talentMypage?.talent?.do_want_scout_email) {
            return
        }
        dispatch(createStatus({
            requestBody: {
                change_job_status_id: talentMypage?.talent?.change_job_status?.id || null, 
                work_parttime_status_id: talentMypage?.talent?.work_part_time_status?.id || null, 
                profession_1_id: talentMypage?.talent?.profession_1_id || null,
                profession_2_id: talentMypage?.talent?.profession_2_id || null,
                profession_3_id: talentMypage?.talent?.profession_3_id || null,
                industry_1_id: talentMypage?.talent?.industry_1_id || null,
                industry_2_id: talentMypage?.talent?.industry_2_id || null,
                industry_3_id: talentMypage?.talent?.industry_3_id || null,
                working_style_1_id: talentMypage.talent?.working_style_1_id || null,
                working_style_2_id: talentMypage.talent?.working_style_2_id || null,
                working_style_3_id: talentMypage.talent?.working_style_3_id || null,
                preferred_city_1_id: talentMypage?.talent?.preferred_city_1_id || null,
                preferred_city_2_id: talentMypage?.talent?.preferred_city_2_id || null,
                preferred_city_3_id: talentMypage?.talent?.preferred_city_3_id || null,
                do_want_news_email: isReceiveNewsEmail,
                do_want_scout_email: isReceiveScoutEmail,
            }
          }),
        );
        setIsEditing(false)
        onClose();
    };
    
    const setters = {
        receiveNewsEmail: setIsReceiveNewsEmail,
        receiveScoutEmail: setIsReceiveScoutEmail,
    };

    const originalValues = {
        receiveNewsEmail: talentMypage?.talent?.do_want_news_email,
        receiveScoutEmail: talentMypage?.talent?.do_want_scout_email,
    };

    const currentValues = {
        receiveNewsEmail: isReceiveNewsEmail,
        receiveScoutEmail: isReceiveScoutEmail,
    };

    const handleCheck = (name, isChecked) => {
        setters[name](isChecked);

        const hasChanged = Object.keys(originalValues).some(key => {
            const newValue = key === name ? isChecked : currentValues[key];
            return newValue !== originalValues[key];
        });

        setIsEditing(hasChanged);
    };




    return (
        <div className="w-[392px] max-w-full h-full bg-white rounded-2xl pt-3 alu-panel-box-shadow">
            <div className="flex items-center justify-between gap-2 px-4 mb-1">
                <h2 className="text-xl leading-[1.875rem] font-bold alu-text-base-2">通知設定</h2>
                <CustomIconButton onClick={onClose} customStyle="shrink-0">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <g clipPath="url(#clip0_8574_265)">
                        <path
                            d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                            fill="currentColor"
                        />
                        </g>
                        <defs>
                        <clipPath id="clip0_8574_265">
                            <rect width="24" height="24" fill="white" />
                        </clipPath>
                        </defs>
                    </svg>
                </CustomIconButton>
            </div>
            <div className="overflow-y-auto custom-scrollbar h-[calc(100%-40px)] px-4 pb-4">
                <form className="mt-6 w-full flex flex-col gap-2">
                    <CheckboxButton
                        name={"receiveNewsEmail"}
                        label={"新着ニュース情報をメールで受け取る"}
                        value={isReceiveNewsEmail}
                        onChange={(value: any) => {handleCheck("receiveNewsEmail", !isReceiveNewsEmail)}}
                    />
                    <CheckboxButton
                        name={"receiveScoutEmail"}
                        label={"スカウトの通知をメールで受け取る"}
                        value={isReceiveScoutEmail}
                        onChange={(value: any) => {handleCheck("receiveScoutEmail", !isReceiveScoutEmail)}}
                    />
                    <div className="flex items-center justify-between gap-4 mt-4">
                        <CustomButton
                            type="button"
                            onClick={() => onClose()}
                            width="full"
                            variant="outline"
                            size="md"
                        >
                            キャンセル
                        </CustomButton>
                        <CustomButton
                            type="button"
                            onClick={() => saveChange()}
                            disabled={isLoading || !isEditing}
                            width="full"
                            size="md"
                        >
                            <p>{isLoading ? "保存中..." : "保存"}</p>
                            {isLoading && (
                                <span><LoadingSpinner /></span>
                            )}
                        </CustomButton>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReceiveNewsEmail;